import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { uploadOperatorDepositSlip } from '../../services'
import { BankMutationKeys } from '../../../keys'

type UseBaseMutationOptions<TData, TVariables> = Omit<
	UseMutationOptions<TData, Error, TVariables, unknown>,
	'mutationKey' | 'mutationFn'
>

interface UploadOperatorDepositSlipParams {
	id: string
	imageUrl: string
}

export default function useMutationUploadOperatorDepositSlip(
	props?: UseBaseMutationOptions<
		{ success: boolean; message: string },
		UploadOperatorDepositSlipParams
	>,
) {
	return useMutation({
		mutationKey: [BankMutationKeys.UploadOperatorDepositSlip],
		mutationFn: (params: UploadOperatorDepositSlipParams) =>
			uploadOperatorDepositSlip(params.id, params.imageUrl),
		...props,
	})
}
